module.exports = __webpack_public_path__ + "name=img/src/assets/img_avatar.png?2fe72bb969b859a452d7b217b38893dc";